import { Component } from "@angular/core";
import { NewBottlerPage } from "../newBottler/newBottler";
import { Events } from "ionic-angular";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { WhiskyDB } from "../../data/db";
import { SublistPage } from "../sublist/sublist";
import { ModalController } from "ionic-angular/components/modal/modal-controller";

@Component({
  selector: "page-bottlers",
  templateUrl: "bottlers.html"
})
export class BottlersPage {
  newBottlerPage: any;
  sublistPage: any;

  constructor(
    private events: Events,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {
    this.initializeItems();
    this.newBottlerPage = NewBottlerPage;
    this.sublistPage = SublistPage;

    // Update event
    this.events.subscribe("bottlers:updated", () => {
      console.log("Got bottlers:updated event");
      // Reapply fiters
      this.getItems(this.lastFilter);
    });

    this.events.subscribe("bottlers:save", () => {
      console.log("Got bottlers:save event");
      WhiskyDB.db.saveBottlers();
    });

    this.events.subscribe("bottlers:add", item => {
      console.log("Got bottlers:add " + item);
      WhiskyDB.bottlers.push(item);
      WhiskyDB.bottlers.sort(function(a, b) {
        return a.localeCompare(b);
      });

      this.events.publish("bottlers:save");
      this.events.publish("bottlers:updated");
    });
  }

  searchQuery: string = "";
  items: any[];
  lastFilter: any = null;

  allItems: any[];
  limit: any = 20;

  initializeItems() {
    // Initial list is unfiltered
    this.getItems(null);
  }

  getItems(ev: any) {
    // Sve the filter
    this.lastFilter = ev;

    // set val to the value of the searchbar
    let val = "";
    if (ev != null) {
      val = ev.target.value;
    }

    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      console.log("Filter=" + val);
      this.allItems = WhiskyDB.bottlers.filter(item => {
        return item.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    } else {
      // Reset items back to all of the items
      this.allItems = WhiskyDB.bottlers;
    }
    this.limit = 20;
    this.items = this.allItems.slice(
      0,
      Math.min(this.limit, this.allItems.length)
    );
  }

  doInfinite(event: any) {
    //console.log("doInfinite");
    // Get next chunk from all filtered & sorted items
    let prior = this.limit;
    this.limit = this.limit + 20;
    //console.log("get more items: " + this.limit);
    this.limit = Math.min(this.limit, this.allItems.length);
    let moreItems = this.allItems.slice(prior, this.limit);

    moreItems.forEach(i => {
      this.items.push(i);
    });

    event.complete();
  }


  remove(toRemove: any, slider: any) {
    slider.close();

    let alert = this.alertCtrl.create({
      title: "Remove Bottler?",
      subTitle: toRemove,
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel remove");
          }
        },
        {
          text: "Remove",
          cssClass: "remove-button",
          handler: () => {
            // Remove selected items
            console.log("Remove: " + toRemove);
            // Remove is via a filter
            WhiskyDB.bottlers = WhiskyDB.bottlers.filter(item => {
              return item != toRemove;
            });

            // Save them
            this.events.publish("bottlers:save");
            // Update them
            this.events.publish("bottlers:updated");
          }
        }
      ]
    });
    alert.present();
  }

  select(item)
  {
    let modal = this.modalCtrl.create(this.sublistPage, { title: item, type: "bottler", bottler: item });
    modal.present();
    //    this.navCtrl.push(this.sublistPage, {title: item, type: "bottler", bottler: item})
  }


  editItem(item, slider) {
    slider.close();
    let prompt = this.alertCtrl.create({
      title: "Edit Shelf",
      inputs: [
        {
          name: "Bottler",
          value: item,
        }
      ],
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Save",
          handler: data => {
            let index = WhiskyDB.bottlers.indexOf(item);

            if (index > -1) {
              console.log("Old: " + item + " new: " + data.Bottler);
              WhiskyDB.bottlers[index] = data.Bottler;
              WhiskyDB.db.saveBottlers();

              WhiskyDB.whisky.forEach(w => {
                if(w.bottler === item)
                  w.bottler = data.Bottler;
              });

              WhiskyDB.db.saveWhisky();
              this.events.publish("whisky:updated");
              this.events.publish("bottlers:updated");
              
              index = this.items.indexOf(item) 
              if(index > -1) this.items[index] = data.Bottler;
              index = this.allItems.indexOf(item);
              if(index > -1) this.allItems[index] = data.Bottler;
              
              this.getItems(this.lastFilter);
            }
          }
        }
      ]
    });

    prompt.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/bottlers/bottlers.ts